import {ChangeDetectionStrategy, Component, ContentChild, input, TemplateRef} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {IonicModule} from '@ionic/angular';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [IonicModule, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="empty-state flex flex-col items-center justify-center px-8 py-12">
      <!-- Icon circle -->
      <div class="relative mb-6">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center">
          <div class="w-16 h-16 rounded-full bg-gray-50 flex items-center justify-center">
            @if (svgIcon()) {
              <ion-icon [src]="svgIcon()" class="text-3xl !text-gray-300"></ion-icon>
            } @else {
              <ion-icon [name]="icon()" class="text-3xl !text-gray-300"></ion-icon>
            }
          </div>
        </div>
        <div class="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-gray-100"></div>
        <div class="absolute -bottom-0.5 -left-1.5 w-2 h-2 rounded-full bg-gray-100"></div>
      </div>

      <!-- Title -->
      <h3 class="text-base font-semibold text-gray-600 text-center mb-1">{{ title() }}</h3>

      <!-- Description -->
      @if (description()) {
        <p class="text-sm text-gray-400 text-center max-w-[240px] leading-relaxed">{{ description() }}</p>
      }

      <!-- Optional action button slot -->
      @if (actionTplRef) {
        <div class="mt-4">
          <ng-container [ngTemplateOutlet]="actionTplRef"></ng-container>
        </div>
      }
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class EmptyStateComponent {
  icon = input<string>('document-text-outline');
  svgIcon = input<string>('');
  title = input<string>('No Data Found');
  description = input<string>('');

  @ContentChild('actionTpl') actionTplRef!: TemplateRef<any>;
}
